import React, {useContext} from 'react';
import { BiSolidRightArrow } from "react-icons/bi";
import { LanguageContext } from "../languages/LanguageContext";
import {FaGlobeAmericas} from "react-icons/fa";
import {ImFacebook2} from "react-icons/im";

const FinishedWork = ({
    projectName,
    school,
    content,
    number,
    date,
    pdfURL,
    imgName,
    video,
    alignment,
    facebookVideo
}) => {
    const { language, translations } = useContext(LanguageContext);
    return (
        <div className='finished-work flex wrap jc-sb'>
            <div className='content-container flex col w-full jc-sb'>
                <div className='title-container flex col'>
                    { content &&
                        <>
                            <h3>{content}</h3>
                            <span className='school flex gap-sm ai-c'><FaGlobeAmericas className='icon'/>{projectName}</span>
                        </>
                    }
                    { !content &&
                        <>
                            <h3>{projectName}</h3>
                            { school &&
                                <span className='school flex gap-sm ai-c'><FaGlobeAmericas className='icon'/> {school}</span>
                            }
                        </>
                    }
                </div>
                { facebookVideo ? (
                    <a href={facebookVideo} className='facebook-video flex ai-c'>
                        <ImFacebook2 />
                        <span>Facebook video</span>
                    </a>
                ) : null}
                <div className='flex col'>
                    <span className='project-date'>{translations[language][date]}</span>
                    <span className='project-number'>{number}</span>
                </div>
                { pdfURL &&
                    <a className='more-button' href={'/docs/projects/' + pdfURL + '.pdf'} target='_blank' rel="noreferrer"><BiSolidRightArrow className='icon' />{translations[language]["readMore"]} {translations[language]["here"]}!</a>
                }
            </div>
            { imgName &&
                <div className='image-container flex jc-fe'>
                    <div className={alignment ? alignment : ''}>
                        <img src={'/images/projects/' + imgName + '-1.jpg'} alt=''/>
                    </div>
                    <div className={alignment ? alignment : ''}>
                        <img src={'/images/projects/' + imgName + '-2.jpg'} alt=''/>
                    </div>
                </div>
            }
            { video &&
                <iframe
                    src={video}
                    title={projectName}
                    allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
                    allowFullScreen>
                </iframe>
            }
        </div>
    );
};

export default FinishedWork;